import { render, staticRenderFns } from "./BlockwellWalletView.vue?vue&type=template&id=2c5ebc65&scoped=true&"
import script from "./BlockwellWalletView.vue?vue&type=script&lang=ts&"
export * from "./BlockwellWalletView.vue?vue&type=script&lang=ts&"
import style0 from "./BlockwellWalletView.vue?vue&type=style&index=0&id=2c5ebc65&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ebc65",
  null
  
)

export default component.exports